import React, { useContext } from 'react';
import { SecondaryButton } from '../../../components/common';
import ServerContext from '../../../contexts/serverContext';
import { PaginationAttributes } from '../../models/pagination-attributes';
interface TopicListItemProps {
    topic: PaginationAttributes;
}
export const PaginationDataListItem = (props: TopicListItemProps) => {
    const serverContext = useContext(ServerContext);
    const currentRoot = serverContext.root
        ? serverContext.root.substring(0, serverContext.root.length - 1)
        : '';
    return (
        <ul className="topic-list">
            <li className="topic" key={props.topic.id}>
                <SecondaryButton
                    className="topic-link"
                    link={`${currentRoot}${props.topic.link}`}
                >
                    {props.topic.label}
                </SecondaryButton>
            </li>
        </ul>
    );
};
